const TabButton = ({ text, isActive, onClick }) => {
  return (
    <div
      className={`relative rounded-b-[15px] w-[140px]
        py-3 flex justify-center items-center
        xl:py-4 
        ${isActive ? "" : ""}`}
    >
      <button
        onClick={onClick}
        className={`${isActive ? "text-purple font-medium" : "text-[#393939]"}`}
      >
        {text}
      </button>
      {isActive && (
        <span
          className="absolute -bottom-[1px] left-1/2 transform -translate-x-1/2
            -translate-y-1/2 w-[80%] h-[3px] rounded-full bg-purple"
        ></span>
      )}
    </div>
  );
};
export default TabButton;
